<template>
    <ckeditor
        :editor="editor"
        :config="config"
        :style="styleObject"
        v-model="markup"
    >
    </ckeditor>
</template>

<script>
    import InlineEditor from '@ckeditor/ckeditor5-build-inline';
    import AxiosUpload from 'ckeditor5-axios-upload/src/axiosupload';
    import input from '../mixins/input';

    export default {
        name: 'VTextEditor',
        mixins: [
            input,
        ],
        props: {
            name: {
                type: String,
            },
            'uploads-endpoint': {
                type: String,
                required: true,
            },
            value: {
                type: String,
            },
        },
        data() {
            return {
                markup: this.value,
                images: [],
            };
        },
        computed: {
            editor() {
                return InlineEditor;
            },
            config() {
                return {
                    language: 'ru',
                    extraPlugins: [
                        AxiosUpload,
                    ],
                    axiosUpload: {
                        uploadUrl:  this.uploadsEndpoint,
                    },
                    heading: {
                        options: [
                            { model: 'paragraph', title: 'Paragraph' },
                            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                            { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' }
                        ]
                    }
                };
            },
            styleObject() {
                return {
                    width: '100%',
                    resize: 'none',
                };
            },
        },
        created() {
            this.images = this.getImagesFromMarkup();
        },
        updated() {
            this.images = this.getImagesFromMarkup();
        },
        methods: {
            getImagesFromMarkup() {
                return Array.from(new DOMParser().parseFromString(this.markup, 'text/html')
                    .querySelectorAll('img'))
                    .map(img => img.getAttribute('src'));
            },
        },
    }
</script>